// Footer/password water duck: on touch (and pen) devices, where hover never fires, a tap sinks the duck under
// the front wave and it springs back up shortly after. Mouse users keep the CSS hover behaviour.
// CSS reads [data-sunk] (see snippets/footer-duck.liquid).
class FooterDuck extends HTMLElement {
  #controller = null;
  #timer = 0;

  connectedCallback() {
    this.#controller = new AbortController();
    this.addEventListener('pointerdown', (event) => this.#onPointerDown(event), {
      passive: true,
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
    clearTimeout(this.#timer);
    this.removeAttribute('data-sunk');
  }

  #onPointerDown(event) {
    if (event.pointerType === 'mouse') return;
    clearTimeout(this.#timer);
    this.setAttribute('data-sunk', '');
    this.#timer = setTimeout(() => this.removeAttribute('data-sunk'), 650);
  }
}

if (!customElements.get('s-footer-duck')) {
  customElements.define('s-footer-duck', FooterDuck);
}
